module.exports = __webpack_public_path__ + "static/buehne_technologien-4dcc3c0400d600497b2005b04f5c2ebb.svg";